import { combineReducers } from "redux";
import authReducer from "./authReducer";
import filterReducer from "./filterReducer";
import searchReducer from "./searchReducer";
import uiReducer from "./uiReducer";
import returnBookletReducer from "../features/return-booklet/slice";
import warningAlertReducer from "../features/warning-notification/warningAlertSlice";
import ticket from "src/features/ticket-encoding/ticketSlice";
// import ctoPaymentReducer from "src/views/payment/cto-payment/features/ctoPaymentSlice";
// import ctoPaymentFilterReducer from "src/views/payment/cto-payment/features/ctoPaymentFilterSlice";

export default combineReducers({
  auth: authReducer,
  search: searchReducer,
  ui: uiReducer,
  filter: filterReducer,
  returnBooklet: returnBookletReducer,
  ticket: ticket,
  alert: warningAlertReducer,
  // ctoPayment: ctoPaymentReducer,
  // ctoPaymentFilter: ctoPaymentFilterReducer,
});
